module.exports = __webpack_public_path__ + "img/flow_icon06.393f9136.png";